import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FlaskConical, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

// "Send me a test": the exact Credit Repair Steps email (short note + PDF) goes to your own inbox first.
export default function TestStepsButton({ reportId, clientName }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const [{ data: me }, { data: rep }] = await Promise.all([
        axios.get(`${API}/api/credit-repair-steps/test-address`),
        axios.get(`${API}/api/ftc-reports/${reportId}`),
      ]);
      await axios.post(`${API}/api/ftc-report/send-credit-repair-steps`, {
        client_name: rep.client_name || clientName || 'Client', client_email: me.email, accounts_by_bureau: rep.accounts_by_bureau || {}, test_to: me.email,
      }, { timeout: 90000 });
      toast.success(`Test sent to ${me.email} — check that it's in your Inbox (not Spam)`);
    } catch (e) { toast.error(e.response?.data?.detail || 'Test send failed'); }
    setBusy(false);
  };
  return (
    <button type="button" onClick={send} disabled={busy} data-testid="crs-test-send"
      className="mx-4 mb-3 flex w-[calc(100%-2rem)] items-center justify-center gap-1.5 rounded-lg border border-sky-500/50 bg-sky-500/10 px-3 py-2 text-xs font-semibold text-sky-100 hover:bg-sky-500/20 disabled:opacity-50">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FlaskConical className="h-4 w-4" />}Send me a test first
    </button>
  );
}
